import { createContext, useContext } from "react";

import { DealBase, IDocumentsActions, IFile, IFolder } from "store/types";

export interface ISelectedItem {
  id: number;
  kind: keyof ISelectState;
  parentId: number | null;
}

export type SelectItemTypes = "folders" | "files";

export type ISelectState = Record<SelectItemTypes, ISelectedItem[]>;

export interface IPickedFile {
  id: number;
  upload_type: string;
  name: string;
}

export interface IFilesPickerContext {
  state: ISelectState;
  setState: React.Dispatch<React.SetStateAction<ISelectState>>;
  isItemSelected: (id: number, kind: keyof ISelectState) => boolean;
  selectItem: (item: ISelectedItem) => void;
  selectedItemsCounter: number;
  addFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
  removeFile: (item: File) => void;
  removeOldFile: (file: IPickedFile) => void;
  attachments: File[];
  oldFiles: IPickedFile[];
  deletedFilesIds: number[];
  resetState: () => void;
  invalidateDataStates: () => void;
  deal: DealBase | null;
  setDeal: (value: DealBase | null) => void;
  step: "select-deal" | "select-files";
  setStep: (value: "select-deal" | "select-files") => void;
  loading: boolean;
  setLoading: (value: boolean) => void;
  foldersLoading: boolean;
  filesLoading: boolean;
  getDealFolders: IDocumentsActions["getDealFoldersAction"];
  files: IFile[];
  preselectFiles: () => void;
  parentFoldersToRender: IFolder[];
  selectAllInFolder: (files: IFile[]) => void;
  resultFolders: IFolder[];
  isSelectionDisabled: (id?: number) => boolean;
  singleFileSelection?: boolean;
  acceptedFilesExtensions?: string[];
  onSelectFileForMe?: () => void;
  isFileForMeSelected?: boolean;
}

export const FilesPickerContext = createContext<IFilesPickerContext>({} as IFilesPickerContext);

export const useFilesPickerContext = (): IFilesPickerContext => useContext(FilesPickerContext);
